import { createContext } from '@lit/context';
import { DataService } from '../services/data_service';

export const dataServiceContext = createContext<DataService>(Symbol('data-service'));
